import { IconChevronRight } from '@divlab/divanui/icons';
import { cn, Price } from '@divlab/divanui';

import SplitLogo from './SplitLogo';
import tags from './tags';
import styles from './YandexSplitCreditTab.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface YandexSplitCreditTabProps extends HTMLAttributes<HTMLDivElement> {
  size?: 's' | 'm';
  amount: number;
  promoTag?: string;
}

const YandexSplitCreditTab: FC<YandexSplitCreditTabProps> = (props) => {
  const { className, amount, promoTag, size = 'm', ...restProps } = props;
  const Tag = tags[promoTag];

  return (
    <div {...restProps} className={cn(styles.wrapper, className, { [styles.small]: size === 's' })}>
      <SplitLogo className={styles.icon} />
      <Price className={styles.price} price={amount} /> в Сплит
      {!!Tag && <Tag />}
      <IconChevronRight className={styles.arrow} />
    </div>
  );
};

export default YandexSplitCreditTab;
